import { Box, Button, Card, CardContent, Typography, Alert } from "@mui/material";
import { csrfToken } from "../api/client";
import { FREEDOM_BLUE } from "../theme";

export default function Login() {
  const error = new URLSearchParams(window.location.search).get("error");
  return (
    <Box sx={{ minHeight: "100vh", display: "grid", placeItems: "center", bgcolor: FREEDOM_BLUE, p: 2 }}>
      <Card sx={{ maxWidth: 400, width: "100%" }}>
        <CardContent sx={{ textAlign: "center", p: 4 }}>
          <img src="/brand/freedom-horizontal-color.png" alt="Freedom Power" style={{ height: 40, marginBottom: 24 }} />
          <Typography variant="h6" sx={{ mb: 1 }}>Social Comment Responder</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Sign in with your Freedom Power Google account.
          </Typography>
          {error && (
            <Alert severity="error" sx={{ mb: 2, textAlign: "left" }}>
              {error === "unauthorized"
                ? "That account isn't authorized yet. Ask an admin to add you."
                : "Sign-in failed. Please try again."}
            </Alert>
          )}
          <form method="post" action="/auth/google_oauth2">
            <input type="hidden" name="authenticity_token" value={csrfToken() || ""} />
            <Button type="submit" fullWidth variant="contained" size="large">Sign in with Google</Button>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
}
